import {
  faAsterisk,
  faBracketsSquare,
  faCalendar,
  faFile,
  faFiles,
  faGlobe,
  faHashtag,
  faLink,
  faListUl,
  faLocationDot,
  faNetworkWired,
  faTags,
  faText,
  faToggleOff,
} from "@fortawesome/pro-regular-svg-icons";
import { faBracketsCurly } from "@fortawesome/pro-solid-svg-icons";

export const DECISION_ERROR_STATUS_CODES = [
  "500",
  "424",
  "422",
  "409",
  "408",
] as const;

export const TYPE_ICONS = {
  string: faText,
  boolean: faToggleOff,
  number: faHashtag,
  integer: faHashtag,
  object: faBracketsCurly,
  array: faBracketsSquare,
  list: faBracketsSquare,
  datetime: faCalendar,
  date: faCalendar,
  any: faAsterisk,
  enum: faListUl,
  tags: faTags,
  tag: faTags,
  address: faLocationDot,
  ipAddress: faNetworkWired,
  latLong: faGlobe,
  url: faLink,
  file: faFile,
  files: faFiles,
};

export const MAX_DISPLAY_COUNT = 99;
